export default __webpack_public_path__ + "static/media/IBMClose.a9cd8730.svg";